import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

const planSteps = [
  { key: 'step1', delay: 400 },
  { key: 'step2', delay: 900 },
  { key: 'step3', delay: 1400 },
  { key: 'step4', delay: 1900 },
]

export default function FeedbackBuildingPlanPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const [completedSteps, setCompletedSteps] = useState<string[]>([])
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    planSteps.forEach((step) => {
      setTimeout(() => {
        setCompletedSteps((prev) => [...prev, step.key])
      }, step.delay)
    })

    setTimeout(() => {
      setIsComplete(true)
    }, 2400)
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center px-4">
          <div className="mb-6 text-6xl">{isComplete ? '✨' : '⏳'}</div>

          <h1 className="custom-heading mb-6 text-2xl leading-tight">
            {isComplete
              ? t('pages.onboarding.feedbackBuildingPlan.completeTitle')
              : t('pages.onboarding.feedbackBuildingPlan.title')}
          </h1>

          <div className="flex w-full max-w-sm flex-col gap-3">
            {planSteps.map((step) => (
              <div
                key={step.key}
                className={`flex items-center gap-3 rounded-xl p-4 transition-all duration-300 ${
                  completedSteps.includes(step.key)
                    ? 'bg-white shadow-sm'
                    : 'bg-gray-100 opacity-50'
                }`}
              >
                <div
                  className={`flex h-8 w-8 items-center justify-center rounded-full transition-all duration-300 ${
                    completedSteps.includes(step.key)
                      ? 'bg-green-500'
                      : 'bg-gray-300'
                  }`}
                >
                  {completedSteps.includes(step.key) ? (
                    <span className="text-sm text-white">✓</span>
                  ) : (
                    <span className="text-sm text-gray-500">○</span>
                  )}
                </div>
                <p
                  className={`text-left text-sm transition-all duration-300 ${
                    completedSteps.includes(step.key)
                      ? 'text-gray-700'
                      : 'text-gray-400'
                  }`}
                >
                  {t(`pages.onboarding.feedbackBuildingPlan.${step.key}`)}
                </p>
              </div>
            ))}
          </div>

          {isComplete && (
            <p className="animate-fade-in mt-6 max-w-sm text-sm text-gray-600">
              {t('pages.onboarding.feedbackBuildingPlan.completeDescription')}
            </p>
          )}
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('pages.onboarding.feedbackBuildingPlan.buttonContinue')}
            type="submit"
            dataTestId="button-continue"
            disabled={!isComplete}
          />
        </Form>
      </div>
    </Layout>
  )
}
